import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class RutHelper {
  constructor() { }

  getRutWithoutDash(rut: string): string {
    if (rut) return rut.replace('-', '');

    return '';
  }

  /**
   * Formatea un RUT chileno en el formato estándar con puntos y guion.
   *
   * @param rut - Cadena que representa el RUT sin formato (sin puntos ni guion).
   * @returns El RUT formateado como 'XX.XXX.XXX-X'.
   *
   * @example
   * ```typescript
   * formatRut("12345678K"); // "12.345.678-K"
   * ```
   */
  public static formatRut(rut: string): string {
    const total = rut.length;
    return `${rut.substring(0, total - 8)}.${rut.substring(total - 8, total - 5)}.${rut.substring(
      total - 5,
      total - 2,
    )}-${rut.substring(total - 1)}`;
  }
}
